import {
  Breadcrumb,
  BreadcrumbButton,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "@hortis/ui/breadcrumb";
import { CheckVerified1, GitBranch1 } from "@hortis/ui/icons";
import { TaxonomicRank } from "generated/graphql";
import {
  taxonomicStatusTextColorMap,
  taxonomicStatusTextHoverColorMap,
} from "src/features/taxonomy/components/taxon-page/taxonomy/taxonomy";
import { twMerge } from "tailwind-merge";
import { type ScientificNameOption } from "../utils";
import { AllRanksHoverCard } from "./all-tanks-hover-card";
import { RankHoverCard } from "./rank-hover-card";
import { SharedScientificNameHoverCard } from "./shared-scientific-name-hover-card";

export const SharedScientificNameInfo = ({
  sharedScientificName,
}: {
  sharedScientificName: ScientificNameOption;
}) => {
  return (
    <div className="flex max-w-full items-center justify-between gap-2 truncate rounded-lg border border-grey-200 bg-grey-25 px-1.5 py-1 shadow-xs">
      {sharedScientificName.classification != null && (
        <Breadcrumb className="truncate">
          <BreadcrumbList className="flex-nowrap gap-x-0 gap-y-0 truncate">
            <BreadcrumbItem className="shrink-0">
              <AllRanksHoverCard
                classification={sharedScientificName.classification}
              >
                <BreadcrumbButton className="cursor-default">
                  <GitBranch1 className="h-4 w-4" />
                </BreadcrumbButton>
              </AllRanksHoverCard>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            {sharedScientificName.classification.family != null && (
              <BreadcrumbItem className="max-w-32 truncate">
                <RankHoverCard
                  rank={TaxonomicRank.Family}
                  scientificName={sharedScientificName.classification.family}
                >
                  <BreadcrumbButton
                    className="cursor-default truncate"
                    data-cy="family-breadcrumb"
                  >
                    <span className="truncate">
                      {sharedScientificName.classification.family}
                    </span>
                  </BreadcrumbButton>
                </RankHoverCard>
              </BreadcrumbItem>
            )}
            <BreadcrumbSeparator />
            <BreadcrumbItem className="truncate">
              <SharedScientificNameHoverCard
                sharedScientificName={sharedScientificName}
              >
                <BreadcrumbButton
                  className={twMerge(
                    "cursor-default gap-1 truncate",
                    taxonomicStatusTextColorMap[sharedScientificName.status],
                    taxonomicStatusTextHoverColorMap[
                      sharedScientificName.status
                    ],
                  )}
                  data-cy="shared-scientific-name-breadcrumb"
                >
                  <CheckVerified1 className="h-4 w-4 shrink-0" />
                  <span className="truncate">
                    {sharedScientificName.scientificName}
                  </span>
                </BreadcrumbButton>
              </SharedScientificNameHoverCard>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      )}
    </div>
  );
};
